import { StyleSheet } from "@react-pdf/renderer";
import React from "react";
import { config } from "./common/config";
import Field from "./common/Field";
import Row from "./common/Row";
import SectionHeader from "./common/SectionHeader";

const styles = StyleSheet.create({
  container: {
    borderLeftColor: config.accentColor,
    borderLeftWidth: 2,
    paddingLeft: 5,
    maxHeight: 15,
  },
  bottomBorder: {
    borderBottomColor: "#118052",
    borderBottomWidth: 2,
    marginBottom: 3,
    paddingTop: 5,
  },
});

const Subtasks = ({ subtasks, label }) => {
  return (
    subtasks.length > 0 && (
      <React.Fragment>
        <Row>
          <SectionHeader style={styles.bottomBorder}>
            Subtarefas de {label}
          </SectionHeader>
        </Row>
        {subtasks.map((sub, i) => (
          <React.Fragment key={Math.random()}>
            <SectionHeader style={{ fontSize: 11, ...styles.container }}>
              Subtarefa {i + 1}: {sub.title}
            </SectionHeader>
            <Row
              style={{
                borderLeftColor: sub.checked ? "#118052" : "#D9534f",
                borderLeftWidth: 2,
                paddingLeft: 5,
              }}
            >
              <Field label="Resolvido">{sub.checked ? "Sim" : "Não"}</Field>
            </Row>
          </React.Fragment>
        ))}
      </React.Fragment>
    )
  );
};

export default Subtasks;
